<template>
  <div class="accordion">
    <module-accordion-item @expand="$emit('expand')">
      <template #header>
        <div>
          <div class="text-base font-base">
            {{ subTitle }}
          </div>
          <div class="text-xl font-semibold mt-1">
            {{ title }}
          </div>
        </div>
      </template>
      <template #default>
        <div v-show="expand">
          <slot></slot>
        </div>
      </template>
      <template #icon>
        <ph-caret-down
          class="accordion-icon transition duration-150 ease-in-out w-8 h-8"
          :class="{ 'transform -rotate-180': expand }"
        />
      </template>
    </module-accordion-item>
    <hr class="mt-10 border-black" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ModuleAccordionItem from '@/components/module/ModuleAccordionItem.vue'
import { PhCaretDown } from '@dnlsndr/vue-phosphor-icons'
export default defineComponent({
  props: {
    expand: {
      type: Boolean,
      default: true,
    },
    subTitle: {
      type: String,
      default: 'Subtitle',
    },
    title: {
      type: String,
      default: 'Title',
    },
  },
  components: { ModuleAccordionItem, PhCaretDown },
})
</script>
